import { SUBDOMAINS } from './subdomainUtils';

export const shouldHideUnifiedSpeedDial = (pathname: string, subdomain: string): boolean => {
  const normalizedPath = pathname.toLowerCase();

  // Hide on backoffice subdomain
  if (subdomain === SUBDOMAINS.BACKOFFICE) {
    return true;
  }

  // Hide on backoffice routes on main domain
  if (normalizedPath.startsWith('/backoffice')) {
    return true;
  }

  // Hide on PWA subdomains
  if (
    subdomain === SUBDOMAINS.ME
    || subdomain === SUBDOMAINS.TEACH
    || subdomain === SUBDOMAINS.CHAT
  ) {
    return true;
  }

  // Hide on K9 PWA routes (canonical /k9-ops/* plus legacy redirects)
  if (subdomain === SUBDOMAINS.K9) {
    const isPWARoute =
      normalizedPath === '/k9-ops/quick-menu' ||
      normalizedPath === '/k9-ops/dashboard' ||
      normalizedPath === '/k9-ops/expense' ||
      normalizedPath === '/quick-menu' ||
      normalizedPath === '/dashboard';
    if (isPWARoute) {
      return true;
    }
  }

  // Hide on backoffice PWA routes
  if (normalizedPath.startsWith('/backoffice-pwa')) {
    return true;
  }

  return false;
};
